module.exports = __webpack_public_path__ + "img/logo_i.ae87ed13.png";